import { create } from 'zustand';
import { createJSONStorage, persist, type StateStorage } from 'zustand/middleware';
import { loadState, removeState, saveState } from '../lib/storage';

/**
 * Session persistence backed by the namespaced, fail-safe storage wrapper.
 * Zustand serialises values to strings; the wrapper JSON-encodes again, which
 * round-trips symmetrically even when storage is unavailable.
 */
export const zustandStorage: StateStorage = {
  getItem: (name) => loadState<string | null>(name, null),
  setItem: (name, value) => saveState(name, value),
  removeItem: (name) => removeState(name),
};

export const jsonStorage = createJSONStorage(() => zustandStorage);

export function uid(prefix = 'id'): string {
  const uuid =
    typeof globalThis.crypto?.randomUUID === 'function'
      ? globalThis.crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return `${prefix}_${uuid}`;
}

export { create, persist };
